import { Component } from '@angular/core'
import { ToastController } from '@ionic/angular'

@Component({
  selector: 'app-widget-error',
  template: ''
})
export class WidgetErrorComponent {
  constructor(private toastController: ToastController) {}

  async presentToast(message: string, duration = 10000) {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'top',
      icon: '../../assets/icon/alert-circle-outline.svg',
      cssClass: 'error'
    })

    await toast.present()
  }
}
